import React from 'react';
import "./style.css";

export default function PeopleList (props){
    const arr = props.data;

    const handleDelete = (e) => {
        props.handleDelete(e.target.previousElementSibling.innerHTML);
    }

    const listItem = arr.map((val, index) => 
        <li key={index}>
            <p>{index}</p>
            <p>{val}</p> 
            <button className="fa fa-trash" onClick={handleDelete}></button>
        </li>
    );

    return (
        <ul>{listItem}</ul>
    )
}